import { getBaseUrl } from '../utils/getBaseUrl';

const baseURL = getBaseUrl() + 'isubject/';

export const DeleteSubject = async (subjectId) => {
    try {
        await fetch(baseURL + 'delete', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: subjectId
        });
        return "Deleted Subject";
    } catch (error) {
        console.error('Error deleting the subject:', error);
    }
};

export const GetAllSubjects = async () => {
    try {
        const response = await fetch(baseURL + 'getall', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error('Error fetching all subject:', error);
    }
};

export const GetSubjectById = async (subjectId) => {
    try {
        const response = await fetch(baseURL + `getbyid?pk=${subjectId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.error(`Error fetching subject by ID (${subjectId}):`, error);
    }
};

export const AddSubject = async (subjectBody) => {
    try {
        await fetch(baseURL + 'add', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: subjectBody
        });
        return "Subject added";
    } catch (error) {
        console.error('Error adding subject:', error);
    }
};